/**
 * Created by Ram on 22/03/2017.
 */

import React from 'react';
import SelectedDevicesList from './AddDevicesToTest/SelectedDevices';
import RemoteConfig from './components/RemoteConfig';

const EditTestInstance = props => {
    const {
        devices,
        scenarios,
        sortLocalAsc,
        sortLocal,
        error,
        success,
        serverError,
        testInstanceId,
        errorField,
        testName,
        scenarioId,
        testMode,
        sdkVersion,
        sdkBuildNumber,
        appVersion,
        duration,
        isProduction,
        enableBackgroundLocationIndicator,
        enableBGMode,
        comments,
        configurationParameters,
        showRemoteConfig
    } = props.loadData;

    const {
        removeDevice,
        removeAllSelectedDevices,
        sortLocalTable,
        navigator,
        updateFormState,
        deleteTestInstance,
        handleAddDevices,
        handleSave,
        displayRemoteConfigDetails,
        handleHideModal,
    } = props;

    let errorMessage = null,
        successMessage = null,
        serverErrorMessage = null;

    if (error) {
        errorMessage = <div className="alert alert-danger"> {error} </div>;
    }

    if (success) {
        successMessage = <h4 className="alert alert-success col-sm-8 col-sm-offset-2 text-center">{success}</h4>;
    }

    if (serverError) {
        serverErrorMessage = (
            <div className="alert alert-danger col-sm-8 col-sm-offset-2 text-center"> {serverError} </div>
        );
    }

    let clearAllButton = '';
    if (devices.length > 0) {
        clearAllButton = (
            <span>
                <button 
                type="button" 
                className="btn mainDivSubmit pull-right" 
                style={{"margin-right":'10px'}}
                onClick={removeAllSelectedDevices}>
                    <span className="glyphicon glyphicon-remove" />
                Clear
                </button>
            </span>
        );
    }

    return (
        <div>
            <ol className="breadcrumb">
                <li><a onClick={navigator.requestTestInstanceManagement}>Test Instance Management</a></li>
                <li className="active">{testInstanceId ? 'Edit Test Instance' : 'Add New Test Instance'}</li>
            </ol>

            <div className="add-new-instance-main-div pull-left">
                <form>
                    {serverErrorMessage}
                    {successMessage}

                    <div className="form-group col-xs-12 col-sm-6">
                        <label
                            htmlFor="testName"
                            className="pull-left"
                            style={{color: errorField === 'testName' ? 'red' : '#429bd5'}}
                        >
                            Test name *
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="testName"
                            placeholder="Test name"
                            name="testName"
                            value={testName}
                            onChange={updateFormState}
                        />
                        {errorField === 'testName' ? errorMessage : ''}
                    </div>
                    <div className="form-group col-xs-12 col-sm-6">
                        <label
                            className="scenarioId"
                            style={{color: errorField == 'scenarioId' ? 'red' : '#429bd5'}}
                        >
                            Scenario
                        </label>
                        <select
                            className="form-control"
                            id="scenarioId"
                            name="scenarioId"
                            value={scenarioId}
                            onChange={updateFormState}
                        >
                            <option value="" disabled selected>
                                Select scenario
                            </option>
                            {scenarios &&
                                scenarios.map(({ _id, name }) => (
                                    <option key={_id} value={_id}>
                                        {' '}
                                        {name}
                                    </option>
                                ))}
                        </select>
                        {errorField === 'scenarioId' ? errorMessage : ''}
                    </div>

                    <div className="form-group col-xs-12 col-sm-6">
                        <label
                            className="testMode"
                            style={{color: errorField === 'testMode' ? 'red' : '#429bd5'}}
                        >
                            Test mode *
                        </label>
                        <select
                            className="form-control"
                            id="testMode"
                            name="testMode"
                            value={testMode}
                            onChange={updateFormState}
                        >
                            <option>Select test mode</option>
                            <option>Host-only</option>
                            <option>Battery-only</option>
                            <option>Both</option>
                        </select>
                        {errorField === 'testMode' ? errorMessage : ''}
                    </div>
                    <div className="form-group col-xs-12 col-sm-6">
                        <label htmlFor="appVersion" className="pull-left">
                            App Version
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="appVersion"
                            placeholder="App version"
                            name="appVersion"
                            value={appVersion}
                            onChange={updateFormState}
                        />
                    </div>
                    <div className="form-group col-xs-12 col-sm-6">
                        <label htmlFor="sdkVersion" className="pull-left">
                            SDK Version *
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="sdkVersion"
                            placeholder="SDK version"
                            name="sdkVersion"
                            value={sdkVersion}
                            onChange={updateFormState}
                        />
                        {errorField === 'sdkVersion' ? errorMessage : ''}
                    </div>
                    <div className="form-group col-xs-12 col-sm-6">
                        <label htmlFor="sdkBuildNumber" className="pull-left">
                            SDK Build Number
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="sdkBuildNumber"
                            placeholder="SDK build number"
                            name="sdkBuildNumber"
                            value={sdkBuildNumber}
                            onChange={updateFormState}
                        />
                    </div>
                    <div className="form-group col-xs-12 col-sm-6">
                        <label
                            htmlFor="startDateTime"
                            className="pull-left"
                            style={{color: errorField == 'duration' ? 'red' : '#429bd5'}}
                        >
                            Duration
                        </label>
                        <input
                            id="duration"
                            name="duration"
                            className="form-control"
                            placeholder="(minutes)"
                            onChange={updateFormState}
                            value={duration}
                        />
                        {errorField === 'duration' ? errorMessage : ''}
                    </div>
                    <div className="form-group col-xs-12 col-sm-6">
                        {errorField === 'remoteConfig' ? errorMessage : ''}
                        <a className="pointer-cursor remote-config" onClick={displayRemoteConfigDetails}>
                            Show Remote Config Details
                        </a>

                        {showRemoteConfig ? (
                            <RemoteConfig
                                handleHideModal={handleHideModal}
                                configurationParameters={configurationParameters}
                            />
                        ) : null}
                    </div>
                    <div className="pull-left col-xs-12">
                        <div className="form-group col-xs-12 col-sm-6">
                            <label>iOS APNs production</label>
                            <div className="">
                                <input
                                    id="cmn-toggle-1"
                                    className="cmn-toggle cmn-toggle-round"
                                    type="checkbox"
                                    name="isProduction"
                                    onChange={updateFormState}
                                    checked={isProduction === true}
                                />
                                <label htmlFor="cmn-toggle-1" />
                            </div>
                        </div>

                        <div className="form-group col-xs-12 col-sm-6">
                            <label>iOS Background Location Usage Indicator</label>
                            <div className="">
                                <input
                                    id="cmn-toggle-2"
                                    className="cmn-toggle cmn-toggle-round"
                                    type="checkbox"
                                    name="enableBackgroundLocationIndicator"
                                    onChange={updateFormState}
                                    checked={enableBackgroundLocationIndicator === true}
                                />
                                <label htmlFor="cmn-toggle-2" />
                            </div>
                        </div>

                        <div className="form-group col-xs-12 col-sm-6">
                            <label>Android BG Mode</label>
                            <div className="">
                                <input
                                    id="cmn-toggle-3"
                                    className="cmn-toggle cmn-toggle-round"
                                    type="checkbox"
                                    name="enableBGMode"
                                    onChange={updateFormState}
                                    checked={enableBGMode === true}
                                />
                                <label htmlFor="cmn-toggle-3" />
                            </div>
                        </div>

                    </div>

                    <div className="form-group col-xs-12">
                        <label htmlFor="comments" className="pull-left">
                            Comments
                        </label>
                        <textarea
                            rows="5"
                            className="form-control"
                            id="comments"
                            placeholder="Comments ..."
                            name="comments"
                            value={comments}
                            onChange={updateFormState}
                        />
                    </div>
                </form>
            </div>

            <div className="add-new-instance-device-list add-new-instance-list pull-right">
                <div className="add-new-instance-device-head text-center">
                    <span className="text-center pull-left">Device list</span>
                    <button type="button" className="btn btn-add mainDivSubmit pull-right" onClick={handleAddDevices}>
                        <span className="glyphicon glyphicon-plus addIcon" />
                        Add
                    </button>
                    {clearAllButton}
                </div>

                <div className="add-new-instance-device-details">
                    <SelectedDevicesList
                        selectedDevices={devices}
                        onRemove={removeDevice}
                        onSort={sortLocalTable}
                        sortBy={sortLocal}
                        isSortAsc={sortLocalAsc}
                    />
                    {errorField == 'selectedDevices' ? errorMessage : ''}
                </div>

                {testInstanceId ? (
                    <a
                        href="#"
                        className="delete-device pull-left"
                        onClick={deleteTestInstance}
                    >
                        Delete Instance
                    </a>
                ) : (
                    ''
                )}
                <button
                    type="button"
                    className="btn btn-primary pull-right new-test-instance-save mainDivSubmit"
                    onClick={handleSave}
                >
                    Save
                </button>
            </div>
        </div>
    ); // return
}; // EditTestInstance

export default EditTestInstance;
